<template>
  <div class="g-content g-detail-layout">
    <!-- 错误信息，取不到数据时显示 -->
    <div class="device-no-exist" v-if="deviceErrorText">
      <div>{{ $t('com_msg_error') }}: {{ deviceErrorText }}</div>
      <div>
        <a-button
          type="default"
          @click="
            () => {
              this.$router.replace({ name: 'Home' });
            }
          "
          icon="double-left"
        >
          {{ $t('com_btn_back') }}
        </a-button>

        <a-button
          type="red"
          @click="
            deleteDeviceBtnClick({
              devId: deviceId,
              name: '',
            })
          "
        >
          {{ $t('com_btn_delete') }}
        </a-button>

        <router-link
          :to="{
            name: 'DeviceUpdate',
            params: { id: deviceId },
          }"
          v-if="AUTH_DEVICE_EDIT"
        >
          <a-button type="primary">
            {{ $t('com_btn_edit') }}
          </a-button>
        </router-link>
      </div>
    </div>

    <div class="g-detail-layout-main-wrapper" v-else-if="deviceStatus && deviceInfo && device">
      <!-- 设备标题 -->
      <div ref="deviceTitleRef" class="g-detail-layout-title device-detail-title">
        <div class="g-detail-layout-title-content device-detail-title-content" id="deviceBaseInfo">
          <div style="width:100%;display: flex;align-items: center;justify-content: space-between;">
            <!-- left -->
            <div class="g-detail-layout-title-left device-detail-title-left">
              <DeviceAvatar
                :avatarType="deviceInfo?.avatar"
                v-if="deviceInfo && deviceInfo.avatar"
              />
              <ul class="device-detail-title-left-r">
                <li style="display: flex; align-items: center;">
                  <!-- <b v-if="device && device.station"> ({{ device.station.name }}) </b> -->
                  <b v-if="deviceInfo">
                    {{ deviceInfo.name || '' }}
                  </b>
                  <!-- 状态 -->
                  <Status
                    :onlineStatus="deviceStatus?.info?.onlineStatus"
                    :faultStatus="deviceStatus?.info?.faultStatus"
                    :workStatus="deviceStatus?.info?.workStatus"
                    :vpnStatus="deviceStatus?.info?.vpnStatus"
                    :disabledStatus="deviceStatus?.info?.disable"
                    :alarmNum="alarmList?.length"
                    :callback="
                      () => {
                        this.showAlarm();
                      }
                    "
                    v-if="deviceStatus && deviceStatus?.info"
                    class="device-detail-title-status"
                  />
                </li>
                <li>
                  <label>{{ $t('device_table_sn') }}:</label
                  ><span>{{ deviceInfo?.devSn | defalutValue }}</span>
                  <label>{{ $t('device_table_soft_version') }}:</label>
                  <span> {{ deviceStatus.info?.versionInfo | defalutValue }}</span>
                </li>
              </ul>
            </div>
            <!-- right -->
            <div class="g-detail-layout-title-right device-detail-title-right">
              <a-dropdown
                overlayClassName="device-detail-control-dropmenu"
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                v-if="
                  (AUTH_DEVICE_WEBUI_CONNECT ||
                    AUTH_DEVICE_SSH_CONNECT ||
                    AUTH_DEVICE_VPN_STOP ||
                    AUTH_DEVICE_CONTROL) &&
                    hasOnline()
                "
              >
                <a-button type="default">
                  {{ $t('device_control_text') }}
                  <a-icon type="down" />
                </a-button>

                <!-- 控制下拉 -->
                <a-menu slot="overlay">
                  <!-- WEBUI -->
                  <a-menu-item
                    key="1"
                    class="device-detail-control-item"
                    v-if="device.supportWeb && hasOnline() && AUTH_DEVICE_WEBUI_CONNECT"
                    @click="showWebUI"
                  >
                    <div>
                      <Icon type="web" />
                      <span>{{ $t('com_btn_webui') }}</span>
                    </div>
                    <!-- 状态是否在线 -->
                    <Icon type="success" v-if="deviceStatus.webui && deviceStatus.webui.webUi" />
                  </a-menu-item>

                  <!-- SSH -->
                  <a-menu-item
                    key="2"
                    class="device-detail-control-item"
                    @click="connectVPN"
                    v-if="device.supportSsh && hasOnline() && AUTH_DEVICE_SSH_CONNECT"
                  >
                    <div>
                      <a-icon type="code" />
                      <span>{{ $t('com_btn_ssh') }}</span>
                    </div>
                    <Icon type="success" v-if="deviceStatus.ssh && deviceStatus.ssh.ssh" />
                  </a-menu-item>

                  <!-- 强制断开VPN -->
                  <a-menu-item
                    key="3"
                    class="device-detail-control-item"
                    @click="closeVPN"
                    v-if="
                      (device.supportSsh || device.supportWeb) &&
                        hasOnline() &&
                        AUTH_DEVICE_VPN_STOP
                    "
                  >
                    <div>
                      <a-icon type="key" />
                      <span>{{ $t('com_btn_close_vpn') }}</span>
                    </div>
                    <Icon
                      type="success"
                      v-if="deviceStatus.info && deviceStatus.info.vpnStatus === 2"
                    />
                  </a-menu-item>

                  <!-- 隔断 -->
                  <a-menu-divider />

                  <!-- 其他做成二级菜单的话，逻辑要变，所以保持原有模式 -->
                  <a-menu-item
                    key="4"
                    class="device-detail-control-item device-detail-control-item-other"
                    @click="sendCommand"
                    v-if="hasOnline() && AUTH_DEVICE_CONTROL"
                  >
                    <!-- <a-icon type="code" /> -->
                    <span>{{ $t('com_btn_other_control') }}</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>

              <!-- 刷新 -->
              <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode">
                <template slot="title">{{ $t('com_btn_refresh') }}</template>
                <a-button
                  type="primary"
                  @click="refresh()"
                  :disabled="firstRefreshLoading || refreshLoading"
                >
                  <a-icon type="loading" v-if="firstRefreshLoading || refreshLoading" />
                  <!-- <span>{{ $t('com_btn_refresh') }}</span> -->
                  <Icon type="refresh" v-else />
                </a-button>
              </a-tooltip>

              <!-- 导出 -->
              <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode">
                <template slot="title">{{ $t('com_btn_export') }}</template>
                <a-button type="primary" @click="handleDetailExport">
                  <a-icon type="upload" />
                </a-button>
              </a-tooltip>

              <!-- 编辑 -->
              <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode">
                <template slot="title">{{ $t('com_btn_edit') }}</template>
                <router-link
                  :to="{
                    name: 'DeviceUpdate',
                    params: { id: deviceInfo.devId },
                  }"
                  v-if="AUTH_DEVICE_EDIT"
                >
                  <a-button type="primary">
                    <Icon type="edit" />
                  </a-button>
                </router-link>
              </a-tooltip>

              <!-- 更多操作 -->
              <a-popover
                trigger="hover"
                placement="bottom"
                overlayClassName="custom-popover-menu custom-popover-noarrow"
                v-if="AUTH_DEVICE_ENABLE_DISABLE || AUTH_DEVICE_DELETE"
              >
                <template slot="content">
                  <ul class="g-ellipsis-menu">
                    <!-- 已禁用 -->
                    <li
                      @click="enableDeviceBtnClick(deviceInfo)"
                      v-if="deviceInfo.disable && AUTH_DEVICE_ENABLE_DISABLE"
                    >
                      <ins><a-icon type="play-circle"/></ins>
                      <span>{{ $t('com_btn_enabled2') }}</span>
                    </li>

                    <!-- 已启用 -->
                    <li
                      @click="disabledDeviceBtnClick(deviceInfo)"
                      v-if="!deviceInfo.disable && AUTH_DEVICE_ENABLE_DISABLE"
                    >
                      <ins><Icon type="forbidden2"/></ins>
                      <span>{{ $t('com_btn_disabled2') }}</span>
                    </li>

                    <!-- 删除 -->
                    <li
                      @click="deleteDeviceBtnClick(deviceInfo)"
                      style="color:red;"
                      v-if="AUTH_DEVICE_DELETE"
                    >
                      <ins> <Icon type="delete"/></ins>
                      <span>{{ $t('com_btn_delete') }}</span>
                    </li>
                  </ul>
                </template>
                <a-button type="primary" class="ant-btn-ellipsis">
                  <Icon type="ellipsis" />
                </a-button>
              </a-popover>

              <!-- 展开 -->
              <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode">
                <template slot="title">{{
                  $t(!showBasicInfo ? 'com_btn_expand' : 'com_btn_collapse')
                }}</template>
                <a-button
                  type="dashed"
                  @click="showBasicInfoFn"
                  class="device-detail-ec-btn"
                  shape="circle"
                >
                  <Icon
                    type="expand"
                    :class="showBasicInfo ? 'device-detail-expand' : 'device-detail-collapse'"
                  />
                </a-button>
              </a-tooltip>
            </div>
          </div>
        </div>
      </div>

      <!-- 基础信息和内容 -->
      <div
        class="device-detail-base-content"
        :class="{ 'base-info-expand': showBasicInfo }"
        ref="deviceBaseContentRef"
        @scroll="fixedSideNav()"
      >
        <!-- 基础信息 -->
        <div
          ref="deviceDetailBaseRef"
          class="device-detail-base"
          id="deviceDetailBase"
          v-if="showBasicInfo"
        >
          <div class="device-detail-base-info">
            <div class="device-detail-base-info-left">
              <h3>{{ $t('device_base_info_title') }}</h3>
              <ul>
                <li>
                  <label>{{ $t('device_table_sn') }}:</label>
                  <span v-if="device.info">{{ device.info.devSn }}</span>
                </li>
                <li>
                  <label>{{ $t('device_base_info_create_date_time') }}:</label>
                  <span>
                    {{ device.ct.executeTime | formatDate }}
                  </span>
                </li>
                <li>
                  <label>{{ $t('device_table_install_date') }}:</label>
                  <span>
                    {{ device.info.instDate | formatDate('yyyy-MM-dd') }}
                  </span>
                </li>
                <li>
                  <label>{{ $t('device_base_info_model') }}:</label>
                  <!-- 跳转到模型 -->
                  <router-link
                    :to="{
                      name: 'DeviceModel',
                      params: { id: device.model.devModelId },
                    }"
                    class="link model"
                    v-if="AUTH_DEVICE_MODEL"
                  >
                    {{ (device.model?.alias || device.model.name) | defalutValue }}
                  </router-link>
                  <span v-else>
                    {{ (device.model?.alias || device.model.name) | defalutValue }}
                  </span>
                </li>
                <li>
                  <label>{{ $t('com_table_created_by') }}:</label>
                  <span>
                    {{ device.ct.executeUserName }}
                  </span>
                </li>

                <li>
                  <label>{{ $t('device_base_info_arrival_date') }}:</label>
                  <span>
                    {{ device.info.birthDate | formatDate('yyyy-MM-dd') }}
                  </span>
                </li>

                <li>
                  <label>{{ $t('device_table_belonged_site') }}:</label>
                  <!-- 跳转到站点 -->
                  <router-link
                    :to="{
                      name: 'SiteDetail',
                      params: { id: device.station.stationId },
                    }"
                    v-if="device.station && AUTH_SITE && AUTH_SITE_DETAIL"
                    class="link site"
                  >
                    {{ device.station.name | defalutValue }}
                  </router-link>
                  <span v-else>
                    {{ device.station.name | defalutValue }}
                  </span>
                </li>
                <li v-if="device && device.info && device.info.maintenanceDay">
                  <label>{{ $t('device_table_maintainace') }}:</label>
                  <span>
                    {{ device.info.maintenanceDay | defalutValue }} {{ $t('com_time_d') }}
                  </span>
                </li>
                <li
                  v-if="device && device.info && device.info.remark"
                  style="width:100%;display:flex"
                >
                  <label class="block">{{ $t('com_form_remark') }}:</label>
                  <span style="flex:1">
                    {{ device.info.remark | defalutValue }}
                  </span>
                </li>
              </ul>
            </div>
            <div
              class="device-detail-base-line-left"
              v-if="AUTH_DEVICE_RUNNING_CONFIG && configInputList && configInputList.length > 0"
            >
              <div></div>
            </div>

            <!-- 此处显示可输入配置项：configInputList -->
            <div
              class="device-detail-base-info-mid"
              v-if="AUTH_DEVICE_RUNNING_CONFIG && configInputList && configInputList.length > 0"
            >
              <h3>{{ $t('device_config_title') }}</h3>
              <ul>
                <li v-for="inputItem in configInputList" :key="inputItem.id" class="inline">
                  <label>{{ inputItem.name }}:</label>
                  <span class="g-refresh-status">
                    <!-- rflag===1为成功 -->
                    <Icon type="status_ok" class="success" v-if="inputItem.rflag === 1" />
                    <Icon type="status_error" class="error" v-else />
                    <em>
                      {{ itemTypes.calcTypeValue(inputItem, inputItem.value) }}
                      {{ inputItem.dataUnit || '' }}
                    </em>
                  </span>
                </li>
              </ul>
            </div>
            <div class="device-detail-base-line-right" v-if="deviceInfo && deviceInfo.icons">
              <div></div>
            </div>
            <!-- 设备图片 -->
            <div class="device-detail-base-info-right">
              <div class="device-detail-base-info-right-img">
                <ImageSlider
                  :listData="deviceInfo.icons"
                  class="device-detail-base-info-right-img-item"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 内容 -->
        <div
          ref="deviceDetailMainRef"
          class="g-detail-layout-main g-device-detail-layout-main"
          v-if="tabLists && tabLists.length > 0"
        >
          <div
            ref="deviceDetailSideRef"
            class="g-detail-layout-main-side g-device-detail-layout-main-side"
          >
            <div id="deviceDetailSideNav" ref="deviceDetailSideNav">
              <h3>{{ $t('device_side_title') }}</h3>
              <ul>
                <li
                  v-for="item in tabLists"
                  :key="item.key"
                  @click="deviceSideChange(item.key)"
                  :class="deviceSideAcitve === item.key ? 'active' : ''"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <div class="g-detail-layout-main-content device-detail-main-content">
            <!-- 运行信息 -->
            <div
              class="device-detail-run-info"
              v-if="deviceSideAcitve === '1' && AUTH_DEVICE_RUNNING_CONFIG"
            >
              <div class="device-detail-main-content-title">
                <h3>
                  {{ $t('device_side_run') }}
                </h3>
                <div class="device-detail-main-content-title-right">
                  <!-- 导出 -->
                  <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode">
                    <template slot="title">{{ $t('com_btn_export') }}</template>
                    <a-button type="default" icon="upload" @click="exportConfigs"> </a-button>
                  </a-tooltip>
                </div>
              </div>

              <div class="device-detail-run-info-list">
                <!-- 配置分类列表 -->
                <div
                  class="device-detail-main-content-action"
                  v-if="currentConfigGroupList && currentConfigGroupList.length"
                >
                  <ul>
                    <li
                      :class="!currentGroupId ? 'active' : ''"
                      @click="filterConfigsByModelGroup()"
                    >
                      {{ $t('com_form_all') }}
                    </li>
                    <li
                      v-for="group in this.currentConfigGroupList"
                      :key="group.groupId"
                      :class="group.groupId === currentGroupId ? 'active' : ''"
                      @click="filterConfigsByModelGroup(group.groupId)"
                    >
                      {{ group.groupName }}
                    </li>
                    <li>
                      <div>
                        <!-- 102表示运行信息 -->
                        <router-link
                          :to="{
                            name: 'DocsDetailType',
                            params: { type: 102 },
                          }"
                          v-auth="['auth_docs_detail']"
                        >
                          <a-icon type="question-circle" />
                        </router-link>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- list -->
                <div class="device-detail-main-content-card">
                  <dl v-for="(groupItem, index) in runConfigList" :key="index">
                    <dt>{{ groupItem.groupName }}</dt>
                    <dd>
                      <ul>
                        <li
                          v-for="configItem in groupItem.groupList"
                          :key="configItem.id"
                          :class="
                            deviceStatus.now - configItem.reTime > oldDataTimeRecord
                              ? 'old-data'
                              : ''
                          "
                        >
                          <ins>{{ configItem.name | defalutValue }}</ins>

                          <!-- rflag===1为成功 -->
                          <!-- 值，鼠标经过时显示上一次的值 -->
                          <div class="g-refresh-status " :title="`${configItem.preValue}`">
                            <Icon type="status_ok" class="success" v-if="configItem.rflag === 1" />
                            <Icon type="status_error" class="error" v-else />

                            <span v-if="configItem.value">
                              {{ itemTypes.calcTypeValue(configItem, configItem.value) }}
                              <span v-if="configItem.dataUnit">
                                {{ configItem.dataUnit }}
                              </span>
                            </span>
                            <span v-else>--</span>
                          </div>
                          <span v-if="configItem.reTime">
                            {{ configItem.reTime | formatDate }}
                          </span>
                          <span v-else>--</span>
                        </li>
                      </ul>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>

            <!-- 配置信息 -->
            <div
              class="device-detail-run-info"
              v-if="deviceSideAcitve === '2' && AUTH_DEVICE_PARAMS_CONFIG"
            >
              <ParamsList
                :device="device"
                :deviceStatus="deviceStatus"
                :deviceStatusFn="getDeviceStatusAll"
                :allGroupList="allGroupList"
                @getParamsList="getParamsList"
                v-if="device && deviceStatus"
                ref="ParamsTab"
              />
            </div>

            <!-- 故障列表 -->
            <div
              class="device-detail-run-info"
              v-if="deviceSideAcitve === '3' && AUTH_DEVICE_FAULT"
            >
              <DetailFault :deviceId="deviceId" />
            </div>

            <!-- 设备记录 -->
            <div class="device-detail-run-info" v-if="deviceSideAcitve === '4' && AUTH_DEVICE_LOG">
              <ParamsLog :deviceId="deviceId" />
            </div>

            <!-- 数据图表 -->
            <div
              class="device-detail-run-info"
              v-if="deviceSideAcitve === '5' && AUTH_DEVICE_CHART"
            >
              <DataChart :deviceId="deviceId" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 告警 -->
    <Alarm :tableHeight="320" ref="alarmElement" v-if="device" />

    <!-- VPN/WEBUI -->
    <VPNUI
      ref="vpnui"
      v-if="device && (AUTH_DEVICE_WEBUI_CONNECT || AUTH_DEVICE_SSH_CONNECT)"
      :device="device"
      :deviceStatus="deviceStatus"
      :deviceStatusFn="getDeviceStatusAll"
    />

    <!-- 弹制关闭VPN -->
    <a-modal
      :visible="closeVPNVisible"
      :confirm-loading="closeVPNConfirmLoading"
      :closable="!closeVPNConfirmLoading"
      @ok="closeVPNCallback"
      @cancel="closeVPNCancel"
      :maskClosable="false"
      destroyOnClose
      centered
      v-if="AUTH_DEVICE_VPN_STOP"
    >
      <p>{{ $t('device_confirm_close_vpn_content') }}</p>

      <template #title>
        <a-icon type="warning" style="margin-right: 10px;color:#faad14" />{{
          $t('device_confirm_close_vpn_title')
        }}
      </template>

      <template #footer>
        <a-button @click="closeVPNCancel" style="margin-right:5px;" v-if="!closeVPNConfirmLoading">
          {{ $t('com_btn_cancel') }}
        </a-button>

        <a-button type="primary" @click="closeVPNCallback" :loading="closeVPNConfirmLoading">
          {{ $t('com_btn_confirm') }}
        </a-button>
      </template>
    </a-modal>

    <!-- 下发命令 -->
    <ControlParams
      ref="control"
      :device="device"
      :httpSupport="httpSupport"
      :configList="paramsConfigList"
      v-if="device && device?.info && AUTH_DEVICE_CONTROL"
    />

    <!-- 导出: 详情信息-->
    <a-modal
      v-model="showExport"
      :title="$t('device_table_export')"
      @cancel="() => (showExport = false)"
      centered
      v-if="showExport"
    >
      <!--导出选项  -->
      <div class="evice-detail-export-filter">
        <a-checkbox-group
          v-model="exportCheckedList"
          :options="exportPlainOptions"
          @change="exportCheckedChange"
        />
      </div>
      <a-input :default-value="exportFileName" v-model="exportFileName">
        <a-select slot="addonAfter" default-value=".xlsx" v-model="exportFileNameExt">
          <a-select-option value=".xlsx">
            .xlsx
          </a-select-option>
        </a-select>
      </a-input>

      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          size="large"
          @click="handleDeviceDetailExport()"
          :loading="exportLoading"
        >
          {{ $t('com_btn_export') }}
        </a-button>
      </template>
    </a-modal>

    <!-- 导出：运行信息 -->
    <ExportParams
      ref="exportConfigs"
      :title="$t('device_export_config_title')"
      v-if="device && device?.info"
      :data="null"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as API from '@/api/device';
import Config from '@/config';
import itemTypes from '@/libs/itemTypes';
import VPNUI from './components/vpnui.vue';
import ControlParams from './components/control.vue';
import Status from './components/status.vue';
import Alarm from './components/alarm.vue';
import DeviceOperation from '@/mixins/device-operation';
import ParamsList from './detail_params.vue';
import ExportParams from './components/export.vue';
import DetailFault from './detail_fault.vue';
import ParamsLog from './detail_log.vue';
import DataChart from './detail_data_chart.vue';
import deviceAuth from '@/views/device/mixins/deviceAuth';
import siteAuth from '@/views/site/mixins/siteAuth';
import { exportExcel } from '@/libs/utils';

export default {
  mixins: [DeviceOperation, deviceAuth, siteAuth],
  components: {
    Status,
    Alarm,
    VPNUI,
    ControlParams,
    ParamsList,
    ExportParams,
    DetailFault,
    ParamsLog,
    DataChart,
  },
  data() {
    return {
      Config,
      itemTypes,
      // 左侧导航
      tabLists: [],
      // 设备id
      deviceId: null,
      // 设备信息
      device: null,
      deviceInfo: null,
      // 新、旧设备状态
      httpSupport: null,
      // 配置信息List
      paramsConfigList: [],
      deviceErrorCode: null,
      deviceErrorText: null,
      // 所有分组列表
      allGroupList: [],
      // 当前配置信息（运行）分组列表
      currentConfigGroupList: null,
      // 配置或运行信息的当前配置类型ID
      currentGroupId: null,

      // 设备状态轮询
      deviceStatus: null,
      deviceStatusPollingTimer: null,
      deviceStatusPollingTime: 15 * 1000,

      // 告警列表
      alarmList: [],

      // 轮询
      timeRunTimer: null,

      // 当前tab
      currentTab: null,

      // 初始刷新状态
      firstRefreshLoading: false,

      // 刷新的状态
      refreshLoading: false,
      refreshWaitingTime: 5 * 1000,
      refreshWaitingTimer: null,

      buttonRefreshStatus: false,

      // close vpn
      closeVPNWaitingTime: 5 * 1000,
      closeVPNVisible: false,
      closeVPNConfirmLoading: false,
      closeVPNConfirmTimer: null,

      // 是否展示基础信息
      showBasicInfo: true,

      // 配置列表
      configList: null,
      // 配置可输入列表
      configInputList: null,

      // 运行信息
      runConfigList: null,

      // 设备左侧tabs
      deviceSideAcitve: '',

      // 第一次轮询请求5秒间隔，后续15秒
      listPollingTimer: null,
      listPollingTimeFisrt: 5 * 1000,
      listPollingTime: 15 * 1000,

      // 配置样式置灰的时间对比值
      oldDataTimeRecord: 60 * 1000,

      sideNav: null,
      deviceTitle: null,

      // 导出详细信息
      showExport: false,
      exportLoading: false,
      exportFileName: '',
      exportFileNameExt: '.xlsx',
      exportDataList: null,

      exportCheckedList: [1, 2, 3, 4],
      exportPlainOptions: [
        // 基础信息
        {
          label: this.$t('device_export_detail_base'),
          value: 1,
        },
        // 设备告警信息
        {
          label: this.$t('device_export_detail_alarm'),
          value: 2,
        },
        // 设备运行信息
        {
          label: this.$t('device_export_detail_runconfig'),
          value: 3,
        },
        // 设备配置信息
        {
          label: this.$t('device_export_detail_params'),
          value: 4,
        },
      ],
      deviceDetailBaseRefHeight: 0, // 基础信息高度
      clearTimeOut: null,
    };
  },

  computed: {
    ...mapGetters(['logout']),
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.deviceId = this.$route.params.id;
    }

    // 初始化tabs
    // 运行信息权限
    if (this.AUTH_DEVICE_RUNNING_CONFIG) {
      this.tabLists.push({
        name: this.$t('device_side_run'),
        key: '1',
      });
    }

    // 配置参数权限
    if (this.AUTH_DEVICE_PARAMS_CONFIG) {
      this.tabLists.push({
        name: this.$t('device_side_config'),
        key: '2',
      });
    }

    // 故障列表
    if (this.AUTH_DEVICE_FAULT) {
      this.tabLists.push({
        name: this.$t('device_side_fault'),
        key: '3',
      });
    }

    // 设备记录
    if (this.AUTH_DEVICE_LOG) {
      this.tabLists.push({
        name: this.$t('device_side_logs'),
        key: '4',
      });
    }

    // 数据图表
    if (this.AUTH_DEVICE_CHART) {
      this.tabLists.push({
        name: this.$t('device_side_data_chart'),
        key: '5',
      });
    }

    // side的默认页面(过滤掉show为false的)
    if (this.tabLists.length > 0) {
      this.deviceSideAcitve = this.tabLists[0].key;
    }

    this.getData();
  },
  beforeDestroy() {
    this.getDeviceStatusAllStop();
    this.setIntervalStop();

    // 清除刷新的等待
    this.stopRefreshWaitingTimer();

    this.stopPolling();

    // window.removeEventListener('scroll', this.fixedSideNav);
  },
  methods: {
    // 导出
    exportCheckedChange() {
      //
    },
    // fixed side nav
    fixedSideNav() {
      // 监听滚动，当#siteDetailSideNav不在可视区域时，固定在顶部
      if (!this.sideNav) {
        this.sideNav = document.getElementById('deviceDetailSideNav');
      }
      if (!this.deviceTitle) {
        this.deviceTitle = document.getElementById('deviceBaseInfo');
      }

      const deviceBaseContentTop = this.$refs.deviceBaseContentRef?.getBoundingClientRect().top;
      const deviceBaseContentRef = this.$refs.deviceBaseContentRef;
      const deviceBaseContent = deviceBaseContentRef?.scrollTop || 0;
      // const clientReact = deviceBaseContentRef.getBoundingClientRect();

      if (this.deviceTitle && this.sideNav) {
        const clientReact = this.deviceTitle.getBoundingClientRect();
        let deviceClientReact = 0;
        if (this.showBasicInfo) {
          const deviceDetailBase = document.getElementById('deviceDetailBase');
          deviceClientReact = deviceDetailBase.getBoundingClientRect().height;
        }
        if (deviceBaseContent > clientReact.height + deviceClientReact - 55) {
          this.sideNav.className = 'site-nav-fixed';
          this.sideNav.style.top = deviceBaseContentTop + 10 + 'px';
        } else {
          this.sideNav.className = 'site-nav-unfixed';
        }
      }
    },

    // side click
    deviceSideChange(key) {
      this.deviceSideAcitve = key;

      // 只有run config的时候才获取数据，其他tab在组件中（组件加载时会获取数据）
      if (key === '1') {
        this.getConfigList();
      } else {
        this.stopPolling();
      }
    },

    // 刷新
    refresh() {
      this.refreshLoading = true;

      this.getDeviceBaseInfo();

      // 先调status
      // this.getDeviceStatusAll();

      // 等待5秒，再调list
      const self = this;
      this.stopRefreshWaitingTimer();
      this.refreshWaitingTimer = setTimeout(function() {
        if (self.deviceSideAcitve === '1') {
          // tab在1时，只刷新运行信息
          self.getConfigList('refresh');
        } else if (self.deviceSideAcitve === '2') {
          // tab在2时，只刷新配置信息
          self.$refs.ParamsTab.getParamsList('refresh');
        } else {
          self.refreshLoading = false;
        }
      }, this.refreshWaitingTime);
    },

    // 清除等待refresh
    stopRefreshWaitingTimer() {
      if (this.refreshWaitingTimer) {
        clearTimeout(this.refreshWaitingTimer);
      }
    },

    // 获取表单数据
    getData() {
      this.loading = true;

      // 设备基础信息
      const _list = [this.getDeviceBaseInfo()];

      // 配置的类型
      if (this.AUTH_DEVICE_MODEL_GROUP) {
        _list.push(this.getAllConfigModelGroupList());
      }

      // 参数
      Promise.all(_list).finally(() => {
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
        this.loading = false;

        // 监听滚动，当#siteDetailSideNav不在可视区域时，固定在顶部
        // window.addEventListener('scroll', this.fixedSideNav);
      });
    },

    // 获取设备基础信息
    getDeviceBaseInfo() {
      return API.DeviceDetail({ id: this.deviceId })
        .then(async res => {
          if (res.code === 0) {
            this.device = res.data;
            this.deviceInfo = res.data.info;
            this.httpSupport = res.data.updt?.httpSupport;
            // 轮询设备状态
            this.getDeviceStatusAll(true);
            this.getParamsList();
          } else {
            this.deviceErrorCode = res.code;
            this.deviceErrorText = res.message;
            this.$store.commit('setPageLoading', false);
          }

          // 记录当前站点路由
          this.$store.commit('setHistoryRouteList', {
            ...this.$route,
            title: this.deviceInfo.name,
            type: 'device',
          });
        })
        .catch(() => {
          this.$store.commit('setPageLoading', false);
        });
    },

    // 获取设备各种状态
    getDeviceStatusAll(init, vpnClose) {
      this.getDeviceStatusAllStop();

      return API.DevicesStatusAll({ devId: this.deviceInfo.devId })
        .then(res => {
          if (res.code === 0 && res.data) {
            this.deviceStatus = res.data;

            // 告警
            this.alarmList = [];
            if (res.data.info && res.data.info.alarmList) {
              this.alarmList = JSON.parse(res.data.info.alarmList || '[]');
            }

            // ssh|webui的时间减少
            if (this.deviceStatus) {
              const self = this;
              this.setIntervalStop();
              const hasWebui = this.deviceStatus.webui && this.deviceStatus.webui.webUi;
              const hasSSH = this.deviceStatus.ssh && this.deviceStatus.ssh.ssh;
              if (hasWebui || hasSSH) {
                this.timeRunTimer = setInterval(function() {
                  if (hasWebui) {
                    self.deviceStatus.webui.webUi.restPeriod--;
                  }
                  if (hasSSH) {
                    self.deviceStatus.ssh.ssh.restPeriod--;
                  }
                }, 1000);
              }

              // 设置高度
              if (!this.deviceDetailBaseRefHeight) {
                this.clearTimeOut = setTimeout(() => {
                  if (this.$refs.deviceDetailBaseRef?.offsetHeight) {
                    this.deviceDetailBaseRefHeight = this.$refs.deviceDetailBaseRef?.offsetHeight;
                    const deviceDetailMainRef = this.$refs.deviceDetailMainRef;
                    deviceDetailMainRef.style.minHeight = `calc(100% - ${this.deviceDetailBaseRefHeight}px - 12px)`;
                    this.clearTimeOut = null;
                  }
                }, 300);
              }
            }
          }
          return res;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);

          // 轮询,15秒1次
          const self = this;
          if (!this.logout) {
            const isCloseVpn =
              vpnClose && this.deviceStatus && this.deviceStatus.info.vpnStatus === 2;

            this.deviceStatusPollingTimer = setTimeout(
              function() {
                if (isCloseVpn) {
                  self.getDeviceStatusAll(false, true);
                } else {
                  self.getDeviceStatusAll();
                }
              },
              isCloseVpn ? 2000 : this.deviceStatusPollingTime
            );
          }
        });
    },

    setIntervalStop() {
      if (this.timeRunTimer) {
        clearInterval(this.timeRunTimer);
      }
    },

    getDeviceStatusAllStop() {
      // 清除轮询
      if (this.deviceStatusPollingTimer) {
        clearTimeout(this.deviceStatusPollingTimer);
      }
    },

    // 获取配置模型Group列表
    getAllConfigModelGroupList() {
      return API.DeviceConfigGroup().then(res => {
        if (res.code === 0) {
          this.allGroupList = res.data;

          // 类型获取成功后
          // 获取配置列表
          this.getConfigList();
        }
      });
    },

    // 展示alarm
    showAlarm() {
      this.$refs.alarmElement.show(this.alarmList);
    },

    // 在线判断
    hasOnline() {
      return (
        this.device &&
        this.deviceStatus &&
        this.deviceStatus.info &&
        this.deviceStatus.info.onlineStatus === 1 &&
        !this.deviceStatus.info.disable
      );
    },

    // webui
    showWebUI() {
      this.$refs.vpnui.show(this.device.info, 'webui');
    },

    // 连接VPN
    connectVPN() {
      this.$refs.vpnui.show(this.device.info, 'ssh');
    },

    // 关闭VPN
    closeVPN() {
      this.closeVPNVisible = true;
    },
    closeVPNCancel() {
      this.closeVPNVisible = false;
    },

    closeVPNCallback() {
      this.closeVPNConfirmLoading = true;
      API.DeviceVpnStop({ devId: this.deviceId })
        .then(res => {
          if (res.code === 0) {
            this.stopCloseVPNConfirmTimer();
            // 等5秒再取消失
            const self = this;
            this.closeVPNConfirmTimer = setTimeout(function() {
              self.$message.success(self.$t('com_msg_close_success'));

              self.device.info.disable = false;

              // 调用status
              if (self.getDeviceStatusAll && typeof self.getDeviceStatusAll === 'function') {
                // self.deviceStatusFn(false, true);
                self.getDeviceStatusAll(false, true);
              }
              self.$refs.vpnui.VPNHasStart = 1;

              self.closeVPNConfirmLoading = false;
              self.closeVPNVisible = false;
            }, this.closeVPNWaitingTime);
          }
        })
        .catch(() => {
          this.closeVPNConfirmLoading = false;
        });
    },
    stopCloseVPNConfirmTimer() {
      if (this.closeVPNConfirmTimer) {
        clearTimeout(this.closeVPNConfirmTimer);
      }
    },

    // 远程命令下发
    sendCommand() {
      this.$refs.control.show(this.device.info, 'ssh');
    },

    // 禁用设备
    disabledDeviceBtnClick(record) {
      this.disabledDeviceInMixins({
        params: { devId: record.devId },
        devName: record.name,
        callback: () => {
          // 刷新状态
          this.refresh();
        },
      });
    },

    // 启用设备
    enableDeviceBtnClick(currentDevice) {
      this.enableDeviceInMixins({
        params: { devId: currentDevice.devId },
        devName: currentDevice.name,
        callback: () => {
          // 刷新状态
          this.refresh();
        },
      });
    },

    // 删除设备
    deleteDeviceBtnClick(currentDevice) {
      this.deleteDeviceInMixins({
        params: { devId: currentDevice.devId },
        devName: currentDevice.name,
        callback: () => {
          // 回到列表
          this.$router.go(-1);
        },
      });
    },

    // 展示基础信息
    showBasicInfoFn() {
      this.showBasicInfo = !this.showBasicInfo;

      // 收起展开时，重设高度
      if (this.showBasicInfo) {
        const deviceDetailMainRef = this.$refs.deviceDetailMainRef;
        deviceDetailMainRef.style.minHeight = `calc(100% - ${this.deviceDetailBaseRefHeight}px - 12px)`;
      } else {
        this.deviceDetailBaseRefHeight = this.$refs.deviceDetailBaseRef?.offsetHeight;
        const deviceDetailMainRef = this.$refs.deviceDetailMainRef;
        deviceDetailMainRef.style.minHeight = '100%';
      }
    },

    // 获取配置信息
    getConfigList(type, firstPolling) {
      const params = {
        devId: this.deviceId,
      };
      const isPolling = type === 'polling' || firstPolling;
      const isRefresh = type === 'refresh';

      if (!isPolling && !isRefresh) {
        this.loading = true;
      }

      return API.DeviceConfigList(params)
        .then(res => {
          if (res.code === 0 && res.data) {
            // 配置列表
            this.configList = res.data.cfgs || [];
            // 可初始化输入的配置
            this.configInputList = res.data.inputCfgs || [];

            // 计算当前配置的配置模型分类
            const _groupList = [];
            const groupIds = Array.from(new Set(this.configList.map(item => item.groupId)));
            if (this.allGroupList && this.allGroupList.length) {
              this.allGroupList.forEach(item => {
                if (groupIds.includes(item.groupId)) {
                  _groupList.push(item);
                }
              });
            }
            // 当前设备的配置模型分类
            this.currentConfigGroupList = _groupList;

            // 默认所有
            if (isPolling || isRefresh) {
              this.filterConfigsByModelGroup('polling');
            } else {
              this.filterConfigsByModelGroup();
            }
          }
        })
        .finally(() => {
          this.loading = false;

          // 第一次轮询调用list结束，更新父级刷新按钮状态
          if (firstPolling) {
            this.firstRefreshLoading = false;
          }
          // 刷新结束
          if (isRefresh) {
            this.refreshLoading = false;
          }

          // 15秒轮询1次
          this.stopPolling();
          if (!this.logout) {
            const self = this;
            this.listPollingTimer = setTimeout(function() {
              self.getConfigList('polling', self.listPollingTimeFisrt);
              self.listPollingTimeFisrt = null;
            }, this.listPollingTimeFisrt || this.listPollingTime);
          }
        });
    },

    // 过滤(通过配置模型分类)
    filterConfigsByModelGroup(groupId) {
      if (groupId !== 'polling') {
        this.currentGroupId = groupId;
      }

      let filterConfigList = [];

      if (!this.currentGroupId) {
        filterConfigList = this.configList;
      } else {
        filterConfigList = this.configList
          ? this.configList.filter(item => item.groupId === this.currentGroupId)
          : [];
      }

      // 按group重新组合数据，同一个groupId的数据放在一起
      let _list = [];
      this.allGroupList.forEach(group => {
        const _group = filterConfigList.filter(item => item.groupId === group.groupId);
        if (_group.length) {
          _list.push({
            groupName: group.groupName,
            groupList: _group,
            len: _group.length,
          });
        }
      });

      // 按len从少到多排序
      _list = _list.sort((a, b) => a.len - b.len);

      this.runConfigList = _list;
    },

    // 停止轮询
    stopPolling() {
      if (this.listPollingTimer) {
        clearTimeout(this.listPollingTimer);
      }
      this.refreshLoading = false;
      this.firstRefreshLoading = false;
    },

    // 导出配置
    exportConfigs() {
      this.$refs.exportConfigs.show(this.device.info, this.configList);
    },

    handleDetailExport() {
      // this.exportFileName = this.handleExportName({ name: `${this.deviceInfo.name}_` });

      this.exportFileName = `${this.deviceInfo.name}-${this.constructor.filter('formatDate')(
        new Date(),
        'yyyyMMddHHmmss'
      )}`;
      this.showExport = true;
    },

    // 导出设备详情的数据
    handleDeviceDetailExport() {
      const self = this;
      // console.log('this.exportCheckedList', this.exportCheckedList);

      // 导出的数据
      const exportData = [];

      // 设备基础信息
      if (this.exportCheckedList.includes(1)) {
        const baseInfoData = {
          // 设备基础信息
          ...this.deviceInfo,
          // model
          devModeldescription: this.device?.model?.description,
          devModelname: this.device?.model?.name,
          devModelId: this.device?.model?.devModelId,
          // station
          stationName: this.device?.station?.name,
          stationId: this.device?.station?.stationId,
          // create
          createInfo: JSON.stringify(this.device?.ct),
          updateInfo: JSON.stringify(this.device?.updt),
        };

        exportData.push({
          name: this.$t('device_export_detail_base'),
          data: [baseInfoData],
        });
      }

      // 设备告警信息
      if (this.exportCheckedList.includes(2)) {
        exportData.push({
          name: this.$t('device_export_detail_alarm'),
          data: this.alarmList || [],
        });
      }

      // 运行信息
      if (this.exportCheckedList.includes(3)) {
        let exportRunConfigList = [];
        this.runConfigList.forEach(item => {
          exportRunConfigList = exportRunConfigList.concat(item.groupList);
        });
        exportData.push({
          name: this.$t('device_export_detail_runconfig'),
          data: exportRunConfigList || [],
        });
      }

      // 配置信息
      if (this.exportCheckedList.includes(4)) {
        exportData.push({
          name: this.$t('device_export_detail_params'),
          data: this.configList || [],
        });
      }

      exportExcel(
        // this.exportDataList || [{ name: this.$t('com_msg_empty') }],
        exportData,
        this.exportFileName + this.exportFileNameExt,
        this.exportFileNameExt,
        function() {
          setTimeout(function() {
            self.exportLoading = false;
            self.showExport = false;
          }, 1000);
        }
      );
    },
    getParamsList() {
      const params = {
        devId: this.device.info.devId,
      };

      return API.DeviceParamsList(params)
        .then(res => {
          if (res.code === 0 && res.data) {
            // 配置
            const configList = res.data.params || [];
            this.backParamsList(configList);
          }
        })
        .finally(() => {});
    },
    backParamsList(configList) {
      this.paramsConfigList = configList;
    },
  },
};
</script>
<style lang="less" scoped>
.site-nav-fixed {
  position: fixed;
  // top: @g-layout-header-height + @g-layout-right-history-height + @g-24px;
  width: 198px;
}

.site-nav-unfixed {
  position: static;
  width: auto;
}

// 标题
.device-detail-title {
  // margin-bottom: 0 !important;
  // 标题内容
  .device-detail-title-content {
    padding: 12px 24px !important;
    height: auto !important;
    display: flex !important;
    flex-direction: column !important;

    .device-detail-title-left {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      svg {
        height: 50px !important;
        width: 50px !important;
        display: flex;
        margin-right: 16px;
      }

      .device-detail-title-left-r {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        position: relative;
        top: 2px;

        li {
          margin: 0;
          padding: 0;
          color: #000;
          font-size: 18px;
          font-weight: 600;

          .device-detail-title-status {
            margin-left: 10px;
          }

          label {
            color: #a0a0a7;
            font-size: 14px;
            font-weight: 400;
            margin-right: 5px;
          }
          span {
            color: #18181a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            margin-right: 10px;
          }
        }
      }
    }

    .device-detail-title-right {
      // 控制的下拉菜单
      .device-detail-control-dropmenu {
        .device-detail-control-item {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          gap: 5px;

          > div {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
          }
        }
        .device-detail-control-item-other {
          padding-left: 10px !important;
          text-align: center !important;
          justify-content: center !important;
        }
      }

      // 展开/收起按钮
      .device-detail-ec-btn {
        color: #1838d9;
        cursor: pointer;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          width: 26px;
          height: 40px;

          // 添加动画效果的过渡属性
          transition: transform 0.3s ease-in-out;

          &.device-detail-expand {
            transform: rotate(180deg);
          }
          &.device-detail-collapse {
            transform: rotate(0deg);
          }
        }
      }
    }
  }
}

// 基础信息
// .device-detail-base-content.base-info-expand {
//   margin-top: 12px;
// }
.device-detail-base-content {
  height: calc(100% - 55px);
  overflow-y: auto;
  border-radius: 12px;
  .device-detail-base {
    padding: 0 24px !important;
    background-color: #fff;
    border-radius: 12px;
    margin-bottom: 12px;
  }
}
.device-detail-base-info {
  padding: 12px 0 0 0;
  background: #fff;
  // margin-top: 8px;
  width: 100%;
  // border-top: 1px solid rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: space-between;

  h3 {
    margin: 0;
    padding: 0;
    line-height: normal;
    color: #000;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  // 基础信息左侧
  .device-detail-base-info-left {
    // width: 60%;
    flex: 1;

    ul {
      display: flex;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        margin-bottom: 8px;
        font-size: 14px;
        word-wrap: break-word;
        word-break: break-all;

        &:nth-child(3n + 1) {
          width: 44%;
        }

        &:nth-child(3n + 2) {
          width: 32%;
        }
        &:nth-child(3n + 3) {
          width: 24%;
        }

        label {
          color: #a0a0a7;
          text-align: right;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          margin-right: 10px;
          width: 100px;
          word-break: keep-all;
        }

        span {
          flex: 1;
          color: #18181a;
          font-size: 14px;
          font-style: normal;
          font-weight: normal;
        }
        a {
          flex: 1;
          font-size: 14px;
          font-weight: normal;
          font-style: normal;
        }
      }
    }
  }

  .device-detail-base-line-left {
    width: 1px;
    display: flex;
    align-items: center;
    margin: 0 18px;
    > div {
      height: 50%;
      width: 1px;
      background: #f0f0f0;
    }
  }

  // 基础信息中间
  .device-detail-base-info-mid {
    width: 27%; // 独立宽度

    ul {
      display: flex;
      flex-direction: column;
      margin: 0;
      padding: 0;
      overflow-y: auto;
      max-height: 100%;
      height: 118px;

      li {
        padding-left: 0;
        margin-left: 0;
        display: flex;
        margin-bottom: 8px;
        font-size: 14px;
        word-wrap: break-word;
        word-break: break-all;
        align-items: flex-start;

        label {
          color: #a0a0a7;
          text-align: right;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          margin-right: 10px;
          word-break: keep-all;
          flex: 1;
          max-width: 58%; /* 设置上限 */
        }

        span {
          color: #18181a;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }

        em {
          font-style: normal;
        }
      }
    }

    .device-detail-base-info-mid-empty {
      margin: 0;
      padding: 0;
      height: 50px;
    }
  }

  // 基础信息右侧
  .device-detail-base-info-right {
    width: 200px;
    max-width: 25%;
    display: flex;

    ul {
      display: flex;
      flex-direction: column;
      margin: 0;

      li {
        display: flex;
        margin-bottom: 8px;
        font-size: 14px;
        word-wrap: break-word;
        word-break: break-all;

        label {
          color: #a0a0a7;
          text-align: right;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          margin-right: 10px;
          flex: 1;
          max-width: 35%;
        }
        span {
          color: #18181a;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }
      }
    }

    .device-detail-base-info-right-img {
      position: relative;
      width: 100%;
      display: flex; // 启用 Flexbox
      align-items: center; // 垂直居中

      .device-detail-base-info-right-img-item {
        width: 100%;
        height: 130px;
      }
    }
  }

  .device-detail-base-line-right {
    width: 1px;
    display: flex;
    align-items: center;
    margin: 0 18px;
    > div {
      height: 50%;
      width: 1px;
      background: #f0f0f0;
    }
  }
}

// content

.g-device-detail-layout-main {
  // margin-top: 12px;
  // margin: 12px 0;
  height: auto !important;
  min-height: calc(100% - 55px - 12px);
  position: relative;
  .g-device-detail-layout-main-side {
    position: absolute;
  }
  .device-detail-main-content {
    margin-left: calc(255px + 16px);
  }
}
::v-deep .device-detail-main-content {
  background: #fff !important;
  border-radius: 12px;
  // 标题
  .device-detail-main-content-title {
    padding: 12px 24px 12px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      padding: 0;
      line-height: normal;
      color: #000;
      font-size: 16px;
      font-weight: 600;
    }

    .device-detail-main-content-title-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
    }
  }

  .device-detail-main-content-action {
    padding: 0 24px;
    ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
      gap: 24px;
      li {
        cursor: pointer;
        color: #18181a;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;

        &.active {
          color: #1838d9;
          border-radius: 5px;
          position: relative;
          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: #1838d9;
            border-radius: 5px;
          }
        }
      }
    }

    .device-detail-main-content-action {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
    }
  }

  .device-detail-run-info {
    .device-detail-run-info-list {
      .device-detail-main-content-card {
        display: flex;
        justify-content: flex-start;
        gap: 12px;
        flex-wrap: wrap;
        margin: 24px;
        align-items: stretch;

        dl {
          border: #ddd solid 1px;
          font-size: 14px;
          width: 100%;
          border-radius: 6px;
          margin: 0;

          &:nth-child(2n) {
            dt {
              background: #f8f8f8;
            }
          }

          dt {
            color: #18181a;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            padding: 6px 16px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 6px 6px 0 0;
          }

          dd {
            padding: 8px 16px;
            margin: 0;

            ul {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              margin: 0;
              justify-content: space-between;

              li {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                width: 45%;
                margin: 0;
                padding: 8px 0;

                &.old-data {
                  color: #aaa;

                  > div {
                    svg {
                      color: #aaa;
                    }
                  }
                }

                &:nth-child(2n) {
                  width: 50%;
                  padding-left: 3%;
                }
                &:nth-child(2n + 1) {
                  width: 50%;
                  border-right: #ddd solid 1px;
                  padding-right: 3%;
                }

                > ins {
                  width: 45%;
                  text-decoration: none;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  gap: 5px;

                  .placeholder {
                    width: 15px;
                  }

                  .ant-checkbox-wrapper {
                    display: flex;
                    align-items: center;
                  }
                }

                > div {
                  width: 28%;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  > span {
                    word-break: break-all;
                    word-wrap: break-word;
                    display: flex;
                    // flex: 1;

                    &.can-edit {
                      color: @primary-color;
                      text-decoration: underline;
                      cursor: pointer;
                    }
                  }
                }
                > span {
                  width: 27%;
                  text-align: right;
                }
              }
            }
          }
        }
      }
      .device-detail-main-content-card:last-child {
        padding-bottom: 20px;
      }
    }
  }
}

.device-title {
  display: flex;
  padding-top: 5px;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
    padding: 0;
    font-size: 14px;
    span {
      padding: 0;
    }
  }
}

.device-title-status {
  border: #eee solid 1px;
  height: 60px;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 4px;
  display: flex;
  align-items: center;

  ul {
    width: 100%;
    display: flex;
    margin: 0;
    li {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      padding-right: 50px;

      label {
        color: #999;
        padding-bottom: 5px;
      }

      &:nth-child(1) {
        padding-left: 10px;
      }

      span {
        &.link {
          text-decoration: underline;
          cursor: pointer;
        }

        &.alarm {
          color: #f00;
          display: inline;
        }
      }
    }
  }
}

.device-button {
  button {
    margin-left: 15px;
  }
}

.device-detail-tab {
  border: none;
  padding: 0;
  position: absolute;
  bottom: -3px;

  span {
    font-size: 14px;
    em {
      font-style: normal;
    }
  }
}

// --------------------
::v-deep .device-refresh {
  height: 35px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
  background: #f9f9f9;
  padding: 0 26px;
  p {
    margin: 0;

    span {
      i {
        font-style: normal;
        background: #ddd;
        padding: 2px 5px;
        border-radius: 3px;
        margin: 0 10px 0 5px;
      }
    }
  }

  button {
    margin-left: 10px;
  }
}

::v-deep .device-config-list {
  .ant-table {
    border-radius: 0 !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: none !important;
    > .ant-table-content {
      border: none;
      overflow-x: auto;
      > .ant-table-body > table > .ant-table-thead > tr > th {
        background: #fff !important;
      }
    }
  }
}

::v-deep .device-config {
  padding: 0 !important;

  .device-group-list {
    padding: 5px 10px 0 10px;
    ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      li {
        padding: 5px 15px;
        font-size: 12px;
        cursor: pointer;

        &.active {
          background: #eee;
          color: #000;
          border-radius: 5px;
        }
      }
    }
  }
}

.device-no-exist {
  font-size: 16px;
  margin: 0 auto;
  text-align: center;
  color: #666;
  background: #fff;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px;
  display: flex;
  height: 100%;

  > div {
    margin-bottom: 20px;
    color: #f00;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
  }
}

// 导出
.evice-detail-export-filter {
  border: #ddd solid 1px;
  background: #fff;
  border-radius: 5px;
  padding: 10px 20px;
  margin-bottom: 20px;

  ::v-deep .ant-checkbox-group {
    display: flex;
    flex-direction: column;

    .ant-checkbox-wrapper {
      padding: 10px 0;
    }
  }
}
</style>
